import navbar from '../components/navbar/navbar.vue';

export default {
  name: 'App',
  components: {
    navbar,
  },
  computed: {
    showNav: function () {
      return this.$route.path !== '/';
    }
  },
};
